import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { UtilsService } from '../../services/utils.service';
import { AoiComponent } from '../aoi/aoi.component';
import { environment } from '../../../environments/environment';
import { ToolsComponent } from '../tools/tools.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements AfterViewInit, OnInit {

    @ViewChild('aboutWindow') private readonly aboutWindow: ElementRef<any>;
    @ViewChild('aoi') private aoi: AoiComponent;
    @ViewChild('aoiWindow') private aoiWindow: ElementRef<any>;
    @ViewChild('bookmarks', { static: true }) private bookmarks: ElementRef<any>;
    @ViewChild('bookmarksWindow', { static: true }) private bookmarksWindow: ElementRef<any>;
    @ViewChild('contactUsWindow') private readonly contactUsWindow: ElementRef<any>;
    @ViewChild('layerCatalog') private readonly layerCatalog: ElementRef<any>;
    @ViewChild('layerCatalogWindow') private readonly layerCatalogWindow: ElementRef<any>;
    @ViewChild('mapCatalog', { static: true }) private readonly mapCatalog: ElementRef<any>;
    @ViewChild('mapCatalogWindow', { static: true }) private readonly mapCatalogWindow: ElementRef<any>;
    @ViewChild('print') private readonly print: ElementRef<any>;
    @ViewChild('printWindow') private readonly printWindow: ElementRef<any>;
    @ViewChild('saveMap') private readonly saveMap: ElementRef<any>;
    @ViewChild('saveMapWindow') private readonly saveMapWindow: ElementRef<any>;
    @ViewChild('search') private readonly search: ElementRef<any>;
    @ViewChild('shareMapWindow', { static: true }) private readonly shareMapWindow: ElementRef<any>;
    @ViewChild('shareMap', { static: true }) private readonly shareMap: ElementRef<any>;
    @ViewChild('tools') private tools: ToolsComponent;
    @ViewChild('unshareMap', { static: true }) private readonly unshareMap: ElementRef<any>;
    @ViewChild('unshareMapWindow', { static: true }) private readonly unshareMapWindow: ElementRef<any>;
    @ViewChild('userSettings', { static: true }) private userSettings: ElementRef<any>;
    @ViewChild('userSettingsWindow', { static: true }) private userSettingsWindow: ElementRef<any>;

    showAboutMenu: boolean = false;
    showLoginMenu: boolean = false;
    showMapMenu: boolean = false;

    constructor(
        private utilsService: UtilsService
    ) { }

    @Input() auth: any;

    ngOnInit(): void {
        this.mapCatalogWindow.nativeElement.addEventListener('openChange', open => {
            this.mapCatalog.nativeElement.active = open.detail;
        });

        this.shareMap.nativeElement.addEventListener('closeShareMap', open => {
            this.shareMapWindow.nativeElement.close();
        });
        this.shareMap.nativeElement.addEventListener('openSaveMap', map => {
            this.saveMapWindow.nativeElement.open();
        });
        this.unshareMap.nativeElement.addEventListener('closeUnshareMap', open => {
            this.unshareMapWindow.nativeElement.close();
        });
    }

    ngAfterViewInit() {
        this.search.nativeElement.excludeTypes = ['map'];
        this.search.nativeElement.filterLayersBeforeAdd = true;
        this.utilsService.aoi = this.aoi;
        this.utilsService.userSettings = this.userSettings;
        const districtsSetting = this.userSettings.nativeElement.userSettingsConfigs.find(x => x.name === 'districts');
        if (districtsSetting) {
            districtsSetting.items = [];
        }
        const districtsSection = (<any>this.userSettings.nativeElement.shadowRoot.querySelector('.setting:first-child'));
        if (districtsSection) {
            districtsSection.style.display = 'none';
        }
        this.utilsService.aoiWindow = this.aoiWindow;
        this.aoi.done.subscribe(_ => this.closeAoi());
        this.closeMenuItemOnPageClick('about', () => { this.showAboutMenu = false; });
        this.closeMenuItemOnPageClick('login', () => { this.showLoginMenu = false; });
        this.closeMenuItemOnPageClick('map', () => { this.showMapMenu = false; });

        this.bookmarksWindow.nativeElement.addEventListener('openChange', open => {
            this.bookmarks.nativeElement.active = open.detail;
        });
        this.userSettingsWindow.nativeElement.addEventListener('openChange', open => {
            this.userSettings.nativeElement.active = open.detail;
        });
    }

    get appId() {
        return environment.appId;
    }

    get isLoggedIn() {
        return this.utilsService.user;
    }

    get rootUrl() {
        return this.utilsService.getRootUrl();
    }

    get imagePath() {
        let path = '';
        if (this.rootUrl) {
            path = this.rootUrl;
        }
        if (!environment.dotNetCore && location.href.indexOf('localhost:') < 0) {
            path += '/wwwroot';
        }
        return path + '/assets/images';
    }

    get mcMap() {
        return this.utilsService.mcMap;
    }

    get username(): string {
        return this.utilsService.user ? this.utilsService.user.fullName : null;
    }

    get version(): string {
        return environment.version;
    }

    openAbout() {
        this.aboutWindow.nativeElement.open();
    }

    openAoi() {
        this.utilsService.openAoi();
    }

    openBookmarks(e: MouseEvent) {
        e.preventDefault();
        this.bookmarksWindow.nativeElement.open();
    }

    openContactUs() {
        this.contactUsWindow.nativeElement.open();
    }

    openLayerCatalog() {
        this.layerCatalogWindow.nativeElement.open();
        this.layerCatalog.nativeElement.active = true;
    }

    openMapCatalog() {
        this.mapCatalog.nativeElement.mergeMaps = false;
        this.mapCatalogWindow.nativeElement.open();
    }

    openPrintWindow() {
        this.utilsService.identify.nativeElement.deactivate();
        this.printWindow.nativeElement.open();
        this.print.nativeElement.active = true;
    }

    openSaveMapWindow() {
        this.saveMapWindow.nativeElement.open();
    }

    openUserSettings(e: MouseEvent) {
        e.preventDefault();
        this.userSettingsWindow.nativeElement.open();
    }

    closeAoi() {
        this.aoiWindow.nativeElement.close();
    }

    closeAbout() {
        this.aboutWindow.nativeElement.close();
    }

    closeLayerCatalog() {
        this.layerCatalogWindow.nativeElement.close();
    }

    closeMapCatalog() {
        this.mapCatalogWindow.nativeElement.close();
    }

    closeMenuItemOnPageClick(cssClass: string, methodToCloseMenuItem: () => void) {
        const body = document.getElementsByTagName('body')[0];
        body.addEventListener('click', (e: any) => {
            const pathClasses = e.composedPath().map(x => x.className);
            if (pathClasses.filter(x => x && x.indexOf(`btn ${cssClass}`) >= 0).length === 0) {
                methodToCloseMenuItem();
            }
        });
    }

    closeContactUs() {
        this.contactUsWindow.nativeElement.close();
    }

    userSettingsActive(event) {
        if (!event.detail) {
            this.userSettingsWindow.nativeElement.close();
        }
    }

    userSettingsLoaded(event) {
        this.utilsService.userSettings = event.detail;
        this.utilsService.setupAOISelections();
    }

    layersAddedFromCatalog(e: CustomEvent<boolean>) {
        this.layerCatalogWindow.nativeElement.close();
    }

    layerCatalogWindowOpenChange(e: CustomEvent<boolean>) {
        if (!e.detail) {
            this.layerCatalog.nativeElement.active = false;
        }
    }

    login() {
        this.utilsService.auth.nativeElement.login();
    }

    logout() {
        this.utilsService.auth.nativeElement.logout();
    }

    toggleAboutMenu() {
        this.showAboutMenu = !this.showAboutMenu;
    }

    toggleLoginMenu() {
        this.showLoginMenu = !this.showLoginMenu;
    }

    toggleMapsMenu() {
        this.showMapMenu = !this.showMapMenu;
    }

    toggleTools() {
        this.tools.visible = !(<any>this.tools).visible;
    }

    onPrintWindowOpenChange(e) {
        if (!e.detail) {
            this.utilsService.identify.nativeElement.activate();
            (<any>this.print).nativeElement.active = false;
        }
    }


}
